import React, { useEffect, useState} from "react";
import LandingModal from "../modals/LandingModal";
import PixelEdumanLoader from "../loading/PixelEdumanLoader";
import NormalSizeLoginBtn from "../buttons/NormalSizeLoginBtn";
import eduheroShield from '../../assets/images/shield-alone.svg';
import loginWords from '../../assets/images/log-in-words.svg';
import InputEmailComp from "../inputs/input/InputEmailComp";
import InputPasswordComp from "../../components/inputs/input/InputPasswordComp";

import "../../assets/css/login/LoginCompCommon.css";
import "../../assets/css/login/Login.css";
// import RedHoverButton from "../buttons/RedHoverButton";
import RedButton from "../buttons/RedButton";
import GreenButton from "../buttons/GreenButton";
import { useNavigate } from "react-router-dom";



const Login = ({controllerState, setControllerState, fetchMessage, setFetchMessage, verifyData}) => {
    const [loading, setLoading] = useState(false);
    const [resetPassword, setResetPassword] = useState(false);
    const [contentForm, setContentForm] = useState({
        email: "",
        password: "",
    });

    const navigate = useNavigate();
    
    
    const setVisibility = () => {
        let pass = document.getElementById('pass');
        if(pass.type == 'password') {
            pass.type = 'text';
        }
        else {
            pass.type = 'password';
        }
    }

    const loginOnClickHandler = (e) => {
        e.preventDefault();
        setFetchMessage(false);
        setLoading(true);

        fetch(`/routes/api/sessions/login/`,
            {
                method: "POST",
                headers: {
                Accepts: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(contentForm),
                credentials: "include"
            }
        )
        .then(res => {
            if(res.ok) {
                return res.json();
            }
            throw new Error();
        })
        .then(data => {
            setLoading(false);

            if(data?.force_refresh && data?.token) {
                navigate("/verify/"+data.token+"/setPassword");
                return;
            } 

            if(data?.token){
                // localStorage.setItem('accessTokenEduhero', data.token);
                setFetchMessage([data.message, data.type]);
                window.location.href = '/client/home';
            }
            else{
                setFetchMessage([data.message, data.type]);
            }
        })
        .catch(err => {
            setLoading(false);
            console.log(err);
            if(err?.type) {
                setFetchMessage(err.message, err.type);
            }
            
        })
        // fetch(`/routes/api/sessions/login/`,
        //     {
        //         method: "POST",
        //         headers: {
        //             Accept: "application/json",
        //             "Content-Type": "application/json"
        //         },
        //         body: JSON.stringify(loginFotmObj)
        //     }
        // )
        // .then(res => {
        //     return res.json();
        // })
        // .then(tokenData => {
        //     localStorage.setItem('accessTokenEduhero', tokenData.token);
        // })
        // .catch(err => {
        //     console.log(err);
            
        // })
    }

    const resetPasswordOnClickHandler = (e) => {
        e.preventDefault();
        setFetchMessage(false);
        setLoading(true);

        fetch(`/routes/api/sessions/resetPass/`,
            {
                method: "POST",
                headers: {
                Accepts: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(contentForm),
                credentials: "include"
            }
        )
        .then(res => {
            if(res.ok) {
                return res.json();
            }
            throw new Error();
        })
        .then(data => {
            setFetchMessage([data.message, data.type]);
            setLoading(false);

            if(data.type === "success") {
                setResetPassword(false);
            }
        })
        .catch(err => {
            console.log(err);
            if(err.hasOwnProperty("type")) {
                setFetchMessage(err.message, err.type);
            }
            
        })
        // fetch(`/routes/api/sessions/login/`,
        //     {
        //         method: "POST",
        //         headers: {
        //             Accept: "application/json",
        //             "Content-Type": "application/json"
        //         },
        //         body: JSON.stringify(loginFotmObj)
        //     }
        // )
        // .then(res => {
        //     return res.json();
        // })
        // .then(tokenData => {
        //     localStorage.setItem('accessTokenEduhero', tokenData.token);
        // })
        // .catch(err => {
        //     console.log(err);
            
        // })
    }

    const loginUpdateFunction = (e, field, value) => {
        if(field) {
            setContentForm(prev => ({
                ...prev,
                [field]: value
            }));
        }
    }

    useEffect(() => {
        if(!controllerState){
            setResetPassword(false);
            setLoading(false);
        }
    }, [controllerState]);

    useEffect(() => {
        if(fetchMessage && resetPassword) {
            setFetchMessage(false);
        }
    }, [resetPassword]);

    return (
        <>
            {   controllerState &&
                (
                    <LandingModal setFalseArr={[setControllerState]} alignRight={true}>
                        <div className='modal--wrapper flex flexCenter'>
                            <div className='loginImgWrapper'>
                                <img src={eduheroShield} alt="Eduhero shield" />
                            </div>
                            <div className='modal--contentWrapper flex flexCenter flexColumn'>
                                {   !resetPassword ?
                                    <>
                                        <div className='modal-header'>
                                            <div className='modal-header-scroller'>
                                                <div className="modal-header-wrapper textAlignCenter">
                                                    <h2>LOG IN</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal--contentContainer flex flexColumn flexAlignCenter">
                                            <form id='loginForm' name={"loginForm"} type="submit" className="flex flexColumn" onSubmit={loginOnClickHandler}>
                                                {fetchMessage && <>
                                                    <div className={"textAlignCenter " + ((fetchMessage[1] === "error") ? "landing-error" : "landing-success")}>
                                                        {fetchMessage[0]}
                                                    </div>
                                                </>}
                                                <label htmlFor="email">Email:</label>
                                                {/* <input name="email" type="test" placeholder="johndoe@schoolisd.net/johnDoe" required /> */}
                                                <InputEmailComp className={"loginSignUpInput"} field={"email"} placeholder={"eduhero@email.net"} required={true} name={"email"} value={contentForm.email} updateFunction={loginUpdateFunction} form={"loginForm"} />

                                                <label htmlFor="password">Password: </label>
                                                <InputPasswordComp className={"loginSignUpPass loginSignUpInput"} eyeClassName={"loginSignUpInput-eye"} field={"password"} name={"password"} placeholder={"Eduh3r012@"} required={true} value={contentForm.password} updateFunction={loginUpdateFunction} form={"loginForm"} />
                                                
                                                {/* button needed for "enter" key submission while focused on input field */}
                                                <button type="submit" hidden></button>
                                            </form>
                                            <div className='login-container flex flexAlignCenter flexJustifySpaceBetween'>
                                                <div className="flex flexAlignCenter modal--contentContainer--buttons landingLoginButton">
                                                    <NormalSizeLoginBtn onClickDo={loginOnClickHandler} > 
                                                        <img src={loginWords} alt='login confirm'></img>
                                                    </NormalSizeLoginBtn>
                                                </div>
                                                <div className='orClass textAlignCenter'>OR</div>
                                                <div className="flex flexCenter">
                                                    <i class="fa-brands fa-google"></i>
                                                    <p>Sign In With Google</p>
                                                </div>                                
                                            </div>
                                            <div className="forgotPass flex flexAlignCenter" onClick={() => setResetPassword(true)}>
                                                <a>Forgot Password?</a>
                                            </div>
                                            {   loading &&
                                                <>
                                                    <PixelEdumanLoader isAbsolute={true} message={"Verifying..."} />
                                                </>
                                            }
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className='modal-header'>
                                            <div className='modal-header-scroller'>
                                                <div className="modal-header-wrapper textAlignCenter">
                                                    <h2>Reset Password</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal--contentContainer flex flexColumn flexAlignCenter">
                                            <form id='loginForm' name={"loginForm"} type="submit" className="flex flexColumn" onSubmit={loginOnClickHandler}>
                                                {fetchMessage && <>
                                                    <div className={"textAlignCenter " + ((fetchMessage[1] === "error") ? "landing-error" : "landing-success")}>
                                                        {fetchMessage[0]}
                                                    </div>
                                                </>}
                                                <label htmlFor="email">Email:</label>
                                                {/* <input name="email" type="test" placeholder="johndoe@schoolisd.net/johnDoe" required /> */}
                                                <InputEmailComp className={"loginSignUpInput"} field={"email"} placeholder={"eduhero@email.net"} required={true} name={"email"} value={contentForm.email} updateFunction={loginUpdateFunction} form={"loginForm"} />
                                            </form>
                                            <div className='login-container flex flexAlignCenter flexJustifySpaceBetween'>
                                                <div className="flex flexAlignCenter modal--contentContainer--buttons landingLoginButton">
                                                    <RedButton setFalseArr={[setResetPassword]} fancyBorder={false} > 
                                                        Cancel
                                                    </RedButton>
                                                </div>
                                                <div className="flex flexCenter">
                                                    <GreenButton onClickDo={resetPasswordOnClickHandler} fancyBorder={false} > 
                                                        Submit
                                                    </GreenButton>
                                                </div>                                
                                            </div>
                                            {   loading &&
                                                <>
                                                    <PixelEdumanLoader isAbsolute={true} message={"Verifying..."} />
                                                </>
                                            }
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </LandingModal>
                )
            }
        </>
    );
};

export default Login;